// extracted by mini-css-extract-plugin
export default {"home":"DateGame_home__JAoVV","logo":"DateGame_logo__w888E","downUp":"DateGame_downUp__UW86j"};